module.exports = __webpack_public_path__ + "static/media/The-Ultimate-Traveller.31f310df.png";